import { PORTAL_LOCALES, type PortalLocale } from '@wally-reseller/shared';
import { cn } from '@wally-reseller/ui/utils';
import { LOCALE_NAMES, useLocale, useT } from '@/lib/i18n';

/** FR | NL. `onChange` lets a signed-in user's choice be saved on their account too. */
export function LanguageSwitch({ onChange }: { onChange?: (locale: PortalLocale) => void }) {
  const { locale, setLocale } = useLocale();
  const t = useT();
  return (
    <div role="group" aria-label={t('portal.language')} className="flex gap-1 text-xs">
      {PORTAL_LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          title={LOCALE_NAMES[l]}
          aria-pressed={l === locale}
          onClick={() => {
            setLocale(l);
            onChange?.(l);
          }}
          className={cn(
            'rounded px-1.5 py-0.5 uppercase',
            l === locale ? 'bg-muted font-semibold' : 'text-muted-foreground hover:bg-muted',
          )}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
